(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-bed-space-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rb-bed-comparison')) {
    customElements.define('rb-bed-comparison', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-compare-scroll]');
        this.controls = this.querySelector('[data-compare-controls]');
        this.previous = this.querySelector('[data-compare-prev]');
        this.next = this.querySelector('[data-compare-next]');
        if (!this.viewport || this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.update = () => {
          const maximum = this.viewport.scrollWidth - this.viewport.clientWidth;
          this.controls.hidden = maximum < 2;
          this.previous.disabled = this.viewport.scrollLeft <= 2;
          this.next.disabled = this.viewport.scrollLeft >= maximum - 2;
        };
        this.move = direction => {
          const style = getComputedStyle(this);
          const distance = this.querySelector('.rb-bed-compare__photo-cell').getBoundingClientRect().width + parseFloat(style.getPropertyValue('--rbc-gap'));
          const position = this.viewport.scrollLeft + direction * distance;
          this.viewport.scrollTo({ left: position, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.viewport.addEventListener('scroll', this.update, { ...options, passive: true });
        // Older Safari versions can pass a swipe at a table edge to the page.
        // Keep native scrolling inside the table; cancel only outward swipes.
        this.viewport.addEventListener('touchstart', event => {
          this.gesture = event.touches.length === 1 ? {
            startX: event.touches[0].clientX,
            startY: event.touches[0].clientY,
            lastX: event.touches[0].clientX,
            axis: null
          } : null;
        }, { ...options, passive: true });
        this.viewport.addEventListener('touchmove', event => {
          if (!this.gesture || event.touches.length !== 1) {
            this.gesture = null;
            return;
          }
          const touch = event.touches[0];
          const x = touch.clientX - this.gesture.startX;
          const y = touch.clientY - this.gesture.startY;
          const delta = touch.clientX - this.gesture.lastX;
          this.gesture.lastX = touch.clientX;
          if (!this.gesture.axis && Math.max(Math.abs(x), Math.abs(y)) > 6) {
            this.gesture.axis = Math.abs(x) > Math.abs(y) ? 'x' : 'y';
          }
          if (this.gesture.axis !== 'x') return;
          const maximum = this.viewport.scrollWidth - this.viewport.clientWidth;
          const atStart = delta > 0 && this.viewport.scrollLeft <= 1;
          const atEnd = delta < 0 && this.viewport.scrollLeft >= maximum - 1;
          if (event.cancelable && (maximum < 2 || atStart || atEnd)) {
            event.preventDefault();
          }
        }, { ...options, passive: false });
        const endGesture = () => { this.gesture = null; };
        this.viewport.addEventListener('touchend', endGesture, { ...options, passive: true });
        this.viewport.addEventListener('touchcancel', endGesture, { ...options, passive: true });
        this.viewport.addEventListener('keydown', event => {
          if (event.target !== this.viewport) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.viewport.scrollTo({ left: event.key === 'Home' ? 0 : this.viewport.scrollWidth, behavior: 'instant' });
          }
        }, options);
        this.resize = new ResizeObserver(this.update);
        this.resize.observe(this.viewport);
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rb-brand-bundle"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rb-complete-bundle')) {
  class RBCompleteBundle extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('[data-rb-bundle-form]');
      this.addButton = this.querySelector('[data-rb-bundle-add]');
      this.label = this.querySelector('[data-rb-bundle-button-label]');
      this.spinner = this.querySelector('.rb-bundle__spinner');
      this.status = this.querySelector('[data-rb-bundle-status]');
      this.cartLink = this.querySelector('[data-rb-bundle-cart-link]');
      this.variants = Array.from(this.querySelectorAll('[data-rb-bundle-variant]'));
      this.originalLabel = this.label?.textContent.trim();
      this.addButton?.addEventListener('click', (event) => {
        if (!this.locked) return;
        event.preventDefault();
        this.navigate(this.dataset.cartUrl);
      });
      this.sizeGuideButton = this.querySelector('[data-rb-bundle-size-open]');
      this.sizeGuideModal = this.querySelector('[data-rb-bundle-size-modal]');
      this.sizeGuideButton?.addEventListener('click', () => {
        if (this.sizeGuideModal && !this.sizeGuideModal.open) this.sizeGuideModal.showModal();
      });
      this.sizeGuideModal?.querySelector('[data-rb-bundle-size-close]')?.addEventListener('click', () => this.sizeGuideModal.close());
      this.sizeGuideModal?.addEventListener('click', (event) => {
        if (event.target !== this.sizeGuideModal) return;
        const box = this.sizeGuideModal.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.sizeGuideModal.close();
      });
      this.sizeGuideModal?.addEventListener('close', () => this.sizeGuideButton?.focus({ preventScroll: true }));
      this.detailsButton = this.querySelector('[data-rb-bundle-details]');
      this.modal = this.querySelector('[data-rb-bundle-modal]');
      this.detailsButton?.addEventListener('click', () => {
        if (!this.modal || this.modal.open) return;
        this.modal.showModal();
        this.detailsButton.setAttribute('aria-expanded', 'true');
      });
      this.modal?.querySelectorAll('[data-rb-bundle-modal-close]').forEach((button) => {
        button.addEventListener('click', () => this.modal.close());
      });
      this.modal?.addEventListener('click', (event) => {
        if (event.target !== this.modal) return;
        const box = this.modal.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.modal.close();
      });
      this.modal?.addEventListener('close', () => {
        this.detailsButton?.setAttribute('aria-expanded', 'false');
        this.detailsButton?.focus({ preventScroll: true });
      });
      this.form?.addEventListener('submit', (event) => this.addBundle(event));
      this.form?.addEventListener('invalid', () => {
        this.status.textContent = this.dataset.chooseMessage;
      }, true);
      this.variants.forEach((field) => field.addEventListener('change', () => {
        this.updatePrice();
        if (!this.busy && !this.locked) this.status.textContent = '';
      }));
    }

    option(field) {
      return field.tagName === 'SELECT' ? field.options[field.selectedIndex] : field;
    }

    navigate(url) {
      window.location.assign(url);
    }

    money(cents) {
      return new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang, {
        style: 'currency', currency: this.dataset.currency || 'EUR'
      }).format(cents / 100);
    }

    updatePrice() {
      let total = 0;
      let compare = 0;
      this.variants.forEach((field) => {
        const option = this.option(field);
        const price = Number(option?.dataset.price) || 0;
        const quantity = Number(field.dataset.quantity) || 1;
        total += price * quantity;
        compare += Math.max(price, Number(option?.dataset.compare) || 0) * quantity;
      });
      const price = this.querySelector('[data-rb-bundle-price]');
      const comparePrice = this.querySelector('[data-rb-bundle-compare]');
      const saving = this.querySelector('[data-rb-bundle-save]');
      if (price && this.dataset.fixedPrice !== 'true') price.textContent = this.money(total);
      if (comparePrice) {
        if (this.dataset.fixedCompare !== 'true') comparePrice.textContent = this.money(compare);
        comparePrice.hidden = this.dataset.showCompare === 'false' || (this.dataset.fixedCompare !== 'true' && compare <= total);
      }
      if (saving) {
        if (this.dataset.fixedSaving !== 'true') saving.textContent = this.dataset.savingTemplate.replace('[amount]', this.money(compare - total));
        saving.hidden = this.dataset.showSaving === 'false' || (this.dataset.fixedSaving !== 'true' && (this.dataset.fixedPrice === 'true' || compare <= total));
      }
    }

    replaceContents(html, selector) {
      if (!html) return;
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      const current = document.querySelector(selector);
      if (next && current) current.innerHTML = next.innerHTML;
    }

    async showCart(data) {
      this.replaceContents(data.sections?.['cart-icon-bubble'], '#cart-icon-bubble');
      this.replaceContents(data.sections?.['cart-notification-button'], '#cart-notification-button');
      if (typeof window.RestingBellyCart?.openOxify === 'function') {
        try {
          let timeout;
          const opened = await Promise.race([
            Promise.resolve().then(() => window.RestingBellyCart.openOxify()),
            new Promise((resolve) => { timeout = window.setTimeout(() => resolve(false), 1500); })
          ]).finally(() => window.clearTimeout(timeout));
          if (opened) return true;
        } catch (_) {}
      }
      const drawer = document.querySelector('cart-drawer');
      const drawerHTML = data.sections?.['cart-drawer'];
      if (drawer?.renderContents && drawerHTML && new DOMParser().parseFromString(drawerHTML, 'text/html').querySelector('#CartDrawer')) {
        drawer.setActiveElement?.(this.addButton);
        drawer.renderContents(data);
        return true;
      }
      const notification = document.querySelector('cart-notification');
      const productArea = notification?.querySelector('#cart-notification-product');
      if (notification?.open && productArea) {
        const message = document.createElement('div');
        message.className = 'rb-bundle__cart-success';
        message.textContent = this.addButton.dataset.successLabel;
        productArea.replaceChildren(message);
        notification.setActiveElement?.(this.addButton);
        notification.open();
        return true;
      }
      return false;
    }

    async addBundle(event) {
      event.preventDefault();
      if (!this.addButton || this.addButton.disabled || this.busy || this.locked) return;
      if (!this.form.reportValidity()) return;
      const unavailable = this.variants.some((field) => field.disabled || this.option(field)?.disabled || field.dataset.available === 'false');
      const selectedItems = this.variants.map((field) => ({ id: Number(field.value), quantity: Number(field.dataset.quantity) || 1 }));
      if (unavailable || selectedItems.length < 1 || selectedItems.some((item) => !Number.isSafeInteger(item.id) || item.id <= 0 || !Number.isInteger(item.quantity) || item.quantity < 1 || item.quantity > 10)) {
        this.status.textContent = this.dataset.unavailableMessage;
        return;
      }
      const mergedItems = new Map();
      selectedItems.forEach((item) => {
        const existing = mergedItems.get(item.id);
        if (existing) existing.quantity += item.quantity;
        else mergedItems.set(item.id, { ...item });
      });
      const items = Array.from(mergedItems.values());
      this.busy = true;
      this.addButton.disabled = true;
      this.addButton.setAttribute('aria-busy', 'true');
      this.label.textContent = this.addButton.dataset.loadingLabel;
      this.spinner.hidden = false;
      this.status.textContent = this.addButton.dataset.loadingLabel;
      this.cartLink.hidden = true;
      const fields = this.variants.filter((field) => field.tagName === 'SELECT');
      fields.forEach((field) => { field.disabled = true; });
      let confirmed = false;
      let redirecting = false;
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          signal: controller.signal,
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items,
            sections: ['cart-drawer', 'cart-notification-button', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });
        const data = await response.json();
        if (!response.ok || data.status >= 400) {
          const message = typeof data.description === 'string' ? data.description : this.dataset.errorMessage;
          const error = new Error(message);
          error.customerMessage = true;
          throw error;
        }
        confirmed = true;
        this.label.textContent = this.addButton.dataset.successLabel;
        this.status.textContent = this.addButton.dataset.successLabel;
        this.cartLink.hidden = false;
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
        const discount = this.addButton.dataset.rbBundleDiscount?.trim();
        if (discount) {
          redirecting = true;
          const root = window.Shopify?.routes?.root || '/';
          this.navigate(root + 'discount/' + encodeURIComponent(discount) + '?redirect=' + encodeURIComponent(this.dataset.cartUrl));
          return;
        }
        let opened = false;
        try { opened = await this.showCart(data); } catch (_) {}
        if (!opened) {
          redirecting = true;
          this.navigate(this.dataset.cartUrl);
        }
      } catch (error) {
        this.locked = true;
        this.cartLink.hidden = false;
        if (confirmed) {
          this.label.textContent = this.addButton.dataset.successLabel;
          this.status.textContent = this.addButton.dataset.successLabel;
          redirecting = true;
          this.navigate(this.dataset.cartUrl);
        } else {
          this.label.textContent = this.cartLink.textContent;
          this.addButton.disabled = false;
          this.status.textContent = (error.customerMessage ? error.message : this.dataset.errorMessage) + ' ' + this.dataset.uncertainMessage;
        }
      } finally {
        window.clearTimeout(timeout);
        this.busy = false;
        this.addButton.removeAttribute('aria-busy');
        this.spinner.hidden = true;
        fields.forEach((field) => { field.disabled = false; });
        if (confirmed && !redirecting && !this.locked) {
          window.setTimeout(() => {
            this.label.textContent = this.originalLabel;
            this.addButton.disabled = false;
          }, 1500);
        }
      }
    }
  }
  customElements.define('rb-complete-bundle', RBCompleteBundle);
}

  } catch(e) { console.error(e); }
})();
})();
